import React from 'react';

function UserSearch({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M4 19.5c0-2.8 2.5-4.5 6-5-2.5-.5-4-2.5-4-5 0-3 2.2-5 4.7-5S16 5.7 16 9v1M15.5 19a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM20 20l-2-2" />
    </svg>
  );
}

export default UserSearch;
